export const getFileExtension = (file) => {
  if (!file) return "";

  const fileName = file.name || "";
  const lastDotIndex = fileName.lastIndexOf(".");

  if (lastDotIndex > -1) {
    return fileName.slice(lastDotIndex).toLowerCase();
  }

  // Fallback to MIME type
  const mimeTypeMap = {
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "image/webp": ".webp",
    "image/gif": ".gif",
    "image/svg+xml": ".svg",
    "application/pdf": ".pdf",
    "application/msword": ".doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
    "application/vnd.ms-excel": ".xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
    "text/plain": ".txt",
    "text/csv": ".csv",
  };

  return mimeTypeMap[file.type] || "";
};